export default {
   "Overview": {
      "title": "Overview",
      "linkTitle": "Overview",
      "hasOnOnlySwitch": true,
      "plotList": [
         {
            "id": "7Vwt1rtxqe7Wjlrl72dx",
            "type": "data3-chart",
            "editDialog": false,
            "config": {
               "layout-overrides": {
                  "title": "Energy Consumption VS Baseline",
                  "colorway": [
                     "#ff7f0e",
                     "#1f77b4",
                     "#2ca02c",
                     "#d62728",
                     "#9467bd",
                     "#8c564b",
                     "#e377c2",
                     "#7f7f7f",
                     "#bcbd22",
                     "#17becf"
                  ],
                  "showlegend": true,
                  "height": 300,
                  "hovermode": "x",
                  "margin": {
                     "l": 30,
                     "r": 20,
                     "t": 50,
                     "pad": 1
                  },
                  "xaxis": {
                     "title": null
                  },
                  "yaxis": {
                     "title": ""
                  },
                  "zaxis": {
                     "title": null
                  }
               },
               "x-axis": "timestamp",
               "y-axis": null,
               "independent-x": false,
               "color-axis": null,
               "color-axis-scale": null,
               "color-axis-title": null,
               "data-payload": [
                  {
                     "filters": {
                        "sensor_name": "Power"
                     },
                     "seriesOverrides": {
                        "type": "scatter",
                        "opacity": 1,
                        "xbins": {
                           "size": 1
                        },
                        "horizontalSummaryMode": false,
                        "mode": "lines"
                     },
                     "pipeline": [
                        {
                           "type": "agg",
                           "agg": "D",
                           "agg_op": "sum",
                           "divide_by_sf": true
                        },
                        {
                           "type": "agg_h",
                           "agg_op": "sum",
                           "name": "Energy (Baseline 1 Week)"
                        }
                     ],
                     "offsetRange": true,
                     "offsetType": "weeks",
                     "offsetAmount": 1,
                     "onOnly": false
                  },
                  {
                     "filters": {
                        "sensor_name": "Power"
                     },
                     "seriesOverrides": {
                        "type": "scatter",
                        "opacity": 1,
                        "xbins": {
                           "size": 1
                        },
                        "horizontalSummaryMode": false,
                        "mode": "lines",
                        "fill": "tozeroy"
                     },
                     "pipeline": [
                        {
                           "type": "agg",
                           "agg": "D",
                           "agg_op": "sum",
                           "divide_by_sf": true
                        },
                        {
                           "type": "agg_h",
                           "agg_op": "sum",
                           "name": "Energy"
                        }
                     ],
                     "offsetRange": false,
                     "offsetType": "weeks",
                     "offsetAmount": 1,
                     "onOnly": false
                  }
               ]
            },
            "flex-class": "lg6"
         },
         {
            "type": "data3-chart",
            "editDialog": false,
            "id": "7Vwt1rtxqe7Wjlrl725x",
            "config": {
               "layout-overrides": {
                  "title": "Energy Consumption Profile",
                  "colorway": [
                     "#1f77b4",
                     "#ff7f0e",
                     "#2ca02c",
                     "#d62728",
                     "#9467bd",
                     "#8c564b",
                     "#e377c2",
                     "#7f7f7f",
                     "#bcbd22",
                     "#17becf"
                  ],
                  "showlegend": true,
                  "height": 300,
                  "hovermode": "x",
                  "margin": {
                     "l": 50,
                     "r": 50,
                     "t": 50,
                     "pad": 1
                  },
                  "xaxis": {
                     "title": "Time"
                  },
                  "yaxis": {
                     "title": "Energy(kwh)"
                  },
                  "zaxis": {
                     "title": null
                  },
                  "barmode": "stack"
               },
               "x-axis": "timestamp",
               "y-axis": null,
               "independent-x": false,
               "color-axis": null,
               "color-axis-scale": null,
               "color-axis-title": null,
               "data-payload": [
                  {
                     "filters": {
                        "sensor_name": "Power",
                        "equipment_type": "Chiller"
                     },
                     "seriesOverrides": {
                        "type": "bar",
                        "opacity": 1,
                        "xbins": {
                           "size": 1
                        }
                     },
                     "pipeline": [
                        {
                           "type": "agg",
                           "agg": "D",
                           "agg_op": "sum",
                           "divide_by_sf": true
                        },
                        {
                           "type": "agg_h",
                           "agg_op": "sum",
                           "name": "Chillers"
                        }
                     ],
                     "offsetRange": false,
                     "offsetType": "months",
                     "offsetAmount": 1,
                     "onOnly": false
                  },
                  {
                     "filters": {
                        "sensor_name": "Power",
                        "equipment_type": "Chilled_Water_Pump"
                     },
                     "seriesOverrides": {
                        "type": "bar",
                        "opacity": 1,
                        "xbins": {
                           "size": 1
                        }
                     },
                     "pipeline": [
                        {
                           "type": "agg",
                           "agg": "D",
                           "agg_op": "sum",
                           "divide_by_sf": true
                        },
                        {
                           "type": "agg_h",
                           "agg_op": "sum",
                           "name": "Pumps"
                        }
                     ],
                     "offsetRange": false,
                     "offsetType": "months",
                     "offsetAmount": 1,
                     "onOnly": false
                  },
                  {
                     "filters": {
                        "sensor_name": "Power",
                        "equipment_type": "AHU"
                     },
                     "seriesOverrides": {
                        "type": "bar",
                        "opacity": 1,
                        "xbins": {
                           "size": 1
                        }
                     },
                     "pipeline": [
                        {
                           "type": "agg",
                           "agg": "D",
                           "agg_op": "sum",
                           "divide_by_sf": true
                        },
                        {
                           "type": "agg_h",
                           "agg_op": "sum",
                           "name": "AHUs"
                        }
                     ],
                     "offsetRange": false,
                     "offsetType": "months",
                     "offsetAmount": 1,
                     "onOnly": false
                  },
                  {
                     "filters": {
                        "sensor_name": "Power",
                        "equipment_type": "COOLING_TOWER"
                     },
                     "seriesOverrides": {
                        "type": "bar",
                        "opacity": 1,
                        "xbins": {
                           "size": 1
                        }
                     },
                     "pipeline": [
                        {
                           "type": "agg",
                           "agg": "D",
                           "agg_op": "sum",
                           "divide_by_sf": true
                        },
                        {
                           "type": "agg_h",
                           "agg_op": "sum",
                           "name": "Cooling Towers"
                        }
                     ],
                     "offsetRange": false,
                     "offsetType": "months",
                     "offsetAmount": 1,
                     "onOnly": false
                  }
               ]
            },
            "flex-class": "lg6"
         },
         {
            "id": "sUcyZzGeDW8xu02VXcBK",
            "type": "fdd-breakdown-widget",
            "editDialog": false,
            "config": {}
         }
      ],
      "published": false,
      "icon": "fa-tachometer-alt"
   }
};
